import React, { useEffect, useRef, useState } from 'react'
import axios from 'axios'
import FilterComponent from '../filter/FilterComponent'
import CropperComponent from '../common/CropperComponent'
import UploadModal from '../common/UploadModal'
import { ReactComponent as UploadIcon } from '../../../assets/icons/upload.svg'
import { useDispatch } from 'react-redux'
import {
    GET_ALL_EXPLORE_DESIGNS,
    GET_FAVOURITE_COUNT,
    SELECT_DESIGN_FOR_FAVOURITE,
    UNSELECT_DESIGN_FOR_FAVOURITE,
    SET_EXPLORE_DESIGNS_LOADING,
    CLEAR_SEARCH_SESSION,
    CLEAR_SEARCH_QUERY
} from '../../redux_toolkit/@types/thunk.types'
import { ExploreDesignThunks } from '../../redux_toolkit/V3/DesignLab/ExploreDesignThunks'
import {
    useExploreDesigns,
    useExploreDesignsLoading,
    useSearchSessionId,
    useSearchQuery,
    ExploreDesignAction
} from '../../redux_toolkit/V3/DesignLab/ExploreDesignSlice'
import DesignCardView from '../common/DesignCardView'
import ScrollTop from '../common/ScrollTop'
import {
    getUserPreference,
    isPageReachBottom,
    setBreadCrumbRoutes,
    getTotalDashboardCount,
    authUserInfo,
    isPickAndChooseBuyer
} from '../../helpers/Util'
import { closeLoader, openLoader, useLoader } from '../../redux_toolkit/Loader'
import { FilterActionTypes, useFilter } from '../../redux_toolkit/V3/Filter'
import {
    exploreDesignFields,
    generateExploreDesignPageParams
} from '../filter/filterUtil'
import AddToFavourite from '../common/AddToFavourite'
import { useNavigate, Link } from 'react-router-dom'
import {
    ADD_FILTER_FIELDS,
    CLEAR_FILTER_FIELDS
} from '../../redux_toolkit/@types/action.types'
import { DoFavouriteThunk } from '../../redux_toolkit/V3/DoFavourite/DoFavouriteThunk'
import BuildRangeRightSidePanel from '../range/BuildRangeRightSidePanel'
import { FavouriteThunks } from '../../redux_toolkit/Favourite/FavouriteThunks'
import {
    addMixpanelTrackingEvent,
    setSystemUserPreferences,
    uploadDocument
} from '../../services/CommonService'
import { fetchCurrentBuyerRequest } from '../../services/v3/Dashboard/Dashborad'
import { useGlobalState } from '../../redux_toolkit/V3/Common'
import { ReactComponent as CollectionFillIcon } from '../../../assets/icons/collection-fill.svg'
import { ReactComponent as CollectionUnFillIcon } from '../../../assets/icons/collection-unfill.svg'
import { LOADER_COLOR } from '../../constant'
import useDocumentTitle from '../../hooks/userDocumentTitle'
import { fetchFilterFieldsThunk } from '../../redux_toolkit/V3/Filter/FilterOptionThunks'
import LoaderComponent from '../../common/LoaderComponent'

const ExploreDesign = () => {
    const [total, setToal] = useState(null)
    const [showMoreDesign, setShowMoreDesign] = useState(true)
    const [showFavourite, setShowFavourite] = useState(false)
    const [openModal, setOpenModal] = useState(false)
    const [viewType, setViewType] = useState(null)
    const [designs, setDesigns] = useState([])
    const [showUploadModal, setShowUploadModal] = useState(false)
    const [backgroundColor, setBackgroundColor] = useState('#068BEE')
    const [filtersCleared, setFiltersCleared] = useState(false)
    const [textdColor, setTextColor] = useState('#FFF')
    const [linkColor, setLinkColor] = useState('#FFF')

    const trackId = useGlobalState()?.productTrackId
    const exploreDesigns = useExploreDesigns()
    const isExploreDesignLoading = useExploreDesignsLoading()
    const isLoading = useRef(null)
    const hasInitialFetch = useRef(false)
    const globalLoader = useLoader()
    const filterStore = useFilter()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const scrollRef = useRef()
    const searchQuery = useSearchQuery()
    const textQuery = searchQuery?.textQuery ?? null
    const imageUrl = searchQuery?.searchImageUrl ?? null
    const searchSessionId = useSearchSessionId()
    const searchSessionIdRef = useRef(null)
    const activeImageUrlRef = useRef(null)
    const cropInitRef = useRef(true)
    const wasSearchingRef = useRef(false)
    const cancelSourceRef = useRef(null)
    // True only for the single fetch triggered by the "explore more" click,
    // so regular filter changes replace results instead of appending.
    const exploreMoreClickRef = useRef(false)
    useDocumentTitle('Nitex - Design Lab')

    useEffect(() => {
        onFetchBuyerRequest()
    }, [])

    useEffect(() => {
        const timer = setTimeout(() => {
            setBackgroundColor('#F5F5F5')
            setLinkColor(LOADER_COLOR)
            setTextColor('#21242B')
        }, 3000)
        return () => clearTimeout(timer)
    }, [])

    const onFetchBuyerRequest = async () => {
        const data = await fetchCurrentBuyerRequest()
        setToal(getTotalDashboardCount(data))
    }

    useEffect(() => {
        let type = getUserPreference()?.exploreDesignViewType || 'LARGE_VIEW'
        setViewType(type)
    }, [])

    const setIsDataLoading = (data) => {
        isLoading.current = data
    }

    useEffect(() => {
        dispatch(
            fetchFilterFieldsThunk({
                fieldsType: exploreDesignFields,
                isExploreDesignPage: true
            })
        )
        if (!filterStore?.mainFabricList && !filterStore?.categoryList) {
            dispatch(FilterActionTypes[CLEAR_FILTER_FIELDS]())
            setFiltersCleared(true)
        }
        return () => {
            dispatch(FilterActionTypes[CLEAR_FILTER_FIELDS]())
            dispatch(ExploreDesignAction[CLEAR_SEARCH_QUERY]())
            if (cancelSourceRef.current) {
                cancelSourceRef.current.cancel()
            }
        }
    }, [])

    useEffect(() => {
        if (filterStore?.mainFabricList || filterStore?.categoryList) {
            setFiltersCleared(true)
        }
    }, [filterStore])

    useEffect(() => {
        setIsDataLoading(globalLoader)
    }, [globalLoader])

    useEffect(() => {
        searchSessionIdRef.current = searchSessionId
    }, [searchSessionId])

    const generateParams = (pageNumber) => {
        let size = 20
        if (pageNumber === 0) size = 40
        if (pageNumber === 1) pageNumber = 2
        let isExploreMore = filterStore?.isMoreExplore ? 'true' : 'false'
        return `?page=${pageNumber}&size=${size}&sort=id,desc&isMoreExplore=${isExploreMore}`
    }

    const generateSearchParams = (pageNumber) => {
        let isExploreMore = filterStore?.isMoreExplore ? 'true' : 'false'
        return `?page=${pageNumber}&size=40&isMoreExplore=${isExploreMore}`
    }

    const buildSearchRequestBody = (pageNumber) => {
        const sid = searchSessionIdRef.current
        if (sid && pageNumber > 0) {
            return { searchSessionId: sid }
        }
        if (sid && pageNumber === 0) {
            const filterBody = generateExploreDesignPageParams(filterStore)
            return { searchSessionId: sid, ...filterBody }
        }
        if (textQuery) return { textQuery }
        if (imageUrl)
            return { searchImageUrl: activeImageUrlRef.current || imageUrl }
        return generateExploreDesignPageParams(filterStore)
    }

    const fetchExploreDesigns = async (pageNumber) => {
        const sid = searchSessionIdRef.current
        const inSearchMode = !!(textQuery || imageUrl || sid)
        // Cancel the previous in-flight request when starting a fresh
        // (page 0) search/crop so racing responses don't overwrite results.
        if (pageNumber === 0 && cancelSourceRef.current) {
            cancelSourceRef.current.cancel('NEW_SEARCH')
        }
        const source = axios.CancelToken.source()
        cancelSourceRef.current = source
        const reqBody = inSearchMode
            ? buildSearchRequestBody(pageNumber)
            : generateExploreDesignPageParams(filterStore)
        const shouldAppendMore = exploreMoreClickRef.current
        exploreMoreClickRef.current = false
        dispatch(
            ExploreDesignThunks[GET_ALL_EXPLORE_DESIGNS](
                inSearchMode
                    ? generateSearchParams(pageNumber)
                    : generateParams(pageNumber),
                inSearchMode ? false : shouldAppendMore,
                reqBody,
                source.token
            )
        )
    }

    useEffect(() => {
        if (textQuery || imageUrl) {
            dispatch(ExploreDesignAction[CLEAR_SEARCH_SESSION]())
            searchSessionIdRef.current = null
            activeImageUrlRef.current = imageUrl
            cropInitRef.current = true
            wasSearchingRef.current = true
            fetchExploreDesigns(0)
            hasInitialFetch.current = true
        } else {
            dispatch(ExploreDesignAction[CLEAR_SEARCH_SESSION]())
            searchSessionIdRef.current = null
            activeImageUrlRef.current = null
            if (wasSearchingRef.current) {
                wasSearchingRef.current = false
                fetchExploreDesigns(0)
            }
        }
    }, [textQuery, imageUrl])

    useEffect(() => {
        if (!textQuery && !imageUrl && !hasInitialFetch.current) {
            fetchExploreDesigns(0)
            hasInitialFetch.current = true
        }
        document.addEventListener('scroll', handleScroll)
        return () => {
            document.removeEventListener('scroll', handleScroll)
        }
    }, [filterStore, filtersCleared])

    useEffect(() => {
        if (hasInitialFetch.current && filtersCleared) {
            fetchExploreDesigns(0)
        }
    }, [filterStore])

    const handleScroll = () => {
        if (isPageReachBottom()) {
            let { totalElements, currentPage, data } = scrollRef.current
            if (
                totalElements > 0 &&
                totalElements !== data.length &&
                !isLoading.current
            ) {
                fetchExploreDesigns(currentPage + 1)
            }
        }
    }

    useEffect(() => {
        setDesigns(exploreDesigns?.data)
        scrollRef.current = exploreDesigns
    }, [exploreDesigns])

    const toggleIsFavourite = async (bool, designInfo, isShowFav = true) => {
        if (designInfo?.availabilityStatus !== 'Sold' && !designInfo?.isSold) {
            setShowFavourite(true)
        } else {
            setShowFavourite(false)
        }
        await dispatch(
            DoFavouriteThunk[SELECT_DESIGN_FOR_FAVOURITE](designInfo, trackId)
        )
        await dispatch(FavouriteThunks[GET_FAVOURITE_COUNT]())
    }

    const onCropChange = async (base64String) => {
        if (cropInitRef.current) {
            cropInitRef.current = false
            return
        }
        if (!base64String) return
        try {
            dispatch(ExploreDesignAction[SET_EXPLORE_DESIGNS_LOADING](true))
            const docMimeType = base64String
                .split(';base64,')[0]
                .split('data:')[1]
            const response = await uploadDocument([
                {
                    name: `design-lab-crop-${Date.now()}.png`,
                    docMimeType: docMimeType || 'image/png',
                    documentType: 'PRODUCT_IMAGE_SEARCH_DATA',
                    base64Str: base64String
                }
            ])
            const croppedUrl = response?.[0]?.docUrl
            if (croppedUrl) {
                activeImageUrlRef.current = croppedUrl
                dispatch(ExploreDesignAction[CLEAR_SEARCH_SESSION]())
                searchSessionIdRef.current = null
                fetchExploreDesigns(0)
            } else {
                dispatch(
                    ExploreDesignAction[SET_EXPLORE_DESIGNS_LOADING](false)
                )
            }
        } catch (e) {
            dispatch(ExploreDesignAction[SET_EXPLORE_DESIGNS_LOADING](false))
        }
    }

    const clearSearch = () => {
        dispatch(ExploreDesignAction[CLEAR_SEARCH_QUERY]())
    }

    const renderDesigns = () => {
        return designs?.map((item, i) => {
            return (
                <React.Fragment key={`single_item_${i}`}>
                    <DesignCardView
                        designInfo={item}
                        triggerIsFavourite={toggleIsFavourite}
                    />
                </React.Fragment>
            )
        })
    }

    const renderExploreMore = () => {
        if (!scrollRef.current) return
        let { totalPages, currentPage } = scrollRef.current
        if (currentPage + 1 === totalPages && showMoreDesign) {
            return (
                <div className='more-design mt-16 mb-8 d-flex justify-center items-center'>
                    <p className='regular-16 mr-6'>
                        Do you want to explore more designs?
                    </p>
                    <button
                        className='button primary mr-3'
                        onClick={() => {
                            exploreMoreClickRef.current = true
                            dispatch(
                                FilterActionTypes[ADD_FILTER_FIELDS]({
                                    data: { isMoreExplore: true }
                                })
                            )
                            addMixpanelTrackingEvent({}, 'BUYER_EXPLORE_MORE')
                        }}
                    >
                        Yes
                    </button>
                    <button
                        className='button secondary'
                        onClick={() => setShowMoreDesign(false)}
                    >
                        No
                    </button>
                </div>
            )
        }
    }

    const routeCollectionPage = () => {
        dispatch(FilterActionTypes[CLEAR_FILTER_FIELDS]())
        let newRoute = '/shared-collection'
        let visitingRoutes = [
            {
                key: '/design-lab',
                value: 'Design Lab'
            },
            {
                key: newRoute,
                value: 'Collections'
            }
        ]

        setBreadCrumbRoutes(visitingRoutes)
        navigate(newRoute)
        addMixpanelTrackingEvent({}, 'BUYER_EXCLUSIVE_FOR_YOU')
    }

    const onCloseModal = () => {
        setOpenModal(false)
    }

    const toggleDesignViewType = async () => {
        try {
            let type =
                getUserPreference()?.exploreDesignViewType === 'NARROW_VIEW'
                    ? 'LARGE_VIEW'
                    : 'NARROW_VIEW'
            dispatch(openLoader())
            await setSystemUserPreferences({
                exploreDesignViewType: type
            })
            setViewType(type)
            dispatch(closeLoader())
        } catch (e) {
            dispatch(closeLoader())
        }
    }

    const renderViewTypeWiseIcon = () => {
        let type =
            getUserPreference()?.exploreDesignViewType === 'NARROW_VIEW'
                ? 'LARGE_VIEW'
                : 'NARROW_VIEW'
        if (type !== 'NARROW_VIEW') {
            return <CollectionFillIcon />
        } else {
            return <CollectionUnFillIcon />
        }
    }

    const getCount = (type, title) => {
        if (total?.[type]?.RUNNING > 0) {
            return total?.[type]?.RUNNING > 1
                ? `${total?.[type]?.RUNNING} ${title.toLowerCase()}s`
                : `${total?.[type]?.RUNNING} ${title.toLowerCase()}`
        } else return null
    }

    const quoteCount = getCount('quotes', 'quote')
    const sampleCount = getCount('sample', 'sample')
    const orderCount = getCount('order', 'order')

    const counts = [quoteCount, sampleCount, orderCount]
        .filter(Boolean)
        .join(', ')

    const renderLink = () => (
        <Link
            style={{ color: linkColor }}
            to='/dashboard?active=QUOTES&status=RUNNING'
            onClick={() =>
                addMixpanelTrackingEvent({}, 'BUYER_DESIGN_LAB_SEE_ALL')
            }
        >
            See all
        </Link>
    )

    const renderText = `You currently have ${counts}. `

    const renderTopBar = () => {
        return (
            <div
                style={{ backgroundColor: backgroundColor }}
                className={'bg text-center py-2 px-4'}
            >
                <p style={{ color: textdColor }} className='text-sm'>
                    {renderText}
                    {renderLink()}
                </p>
            </div>
        )
    }

    const getNumberCount = () => {
        let isValid = false
        if (total?.['quotes']?.RUNNING > 0) {
            isValid = true
        }
        if (total?.['sample']?.RUNNING > 0) {
            isValid = true
        }
        if (total?.['order']?.RUNNING > 0) {
            isValid = true
        }
        return isValid
    }

    const getBuyerWiseFilterFields = (exploreDesignFields) => {
        return !isPickAndChooseBuyer()
            ? (({ PRICE_RANGE, ...rest }) => rest)(exploreDesignFields)
            : exploreDesignFields
    }

    const isSearchMode = !!(textQuery || imageUrl)

    const renderSearchBar = () => {
        if (!isSearchMode) return null
        return (
            <div className='design-lab-search-bar'>
                {imageUrl ? (
                    <div className='image-search-bar'>
                        <div className='crop-box'>
                            <CropperComponent
                                imageSrc={imageUrl}
                                className='w-full h-full object-contain bg-image'
                                callback={onCropChange}
                            />
                        </div>
                        <div className='search-bar-info'>
                            <h3 className='title'>Visual matches</h3>
                            <p className='subtitle'>
                                Drag or resize the box on the image to refine
                                your search.
                            </p>
                            <div className='search-bar-actions'>
                                <button
                                    className='button primary sm'
                                    onClick={() => setShowUploadModal(true)}
                                >
                                    <span className='mr-2'>Upload image</span>
                                    <UploadIcon />
                                </button>
                                <button
                                    className='button secondary sm'
                                    onClick={clearSearch}
                                >
                                    Clear search
                                </button>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className='text-search-bar'>
                        <div className='search-bar-info'>
                            <div className='d-flex items-center'>
                                <h3 className='title'>Search results</h3>
                                <button
                                    className='button secondary sm ml-4'
                                    onClick={clearSearch}
                                >
                                    Clear search
                                </button>
                            </div>
                            <p className='subtitle'>
                                Showing results for{' '}
                                <span className='font-bold black'>
                                    {`"${textQuery}"`}
                                </span>
                            </p>
                        </div>
                    </div>
                )}
            </div>
        )
    }

    return (
        <LoaderComponent
            loading={isSearchMode ? false : isExploreDesignLoading}
        >
            {total && getNumberCount() && renderTopBar()}
            <FilterComponent
                requiredFields={getBuyerWiseFilterFields(exploreDesignFields)}
                filteredDataLength={designs?.length}
                extraClass={'on-explore-design'}
            >
                <button
                    className='button icon-only boder-0'
                    onClick={toggleDesignViewType}
                >
                    {renderViewTypeWiseIcon()}
                </button>

                <button
                    className='button secondary-blue round sm'
                    onClick={routeCollectionPage}
                >
                    <span className='mr-2'>Exclusive for you</span>
                </button>
            </FilterComponent>
            <div className='page-content relative px-4'>
                {renderSearchBar()}
                <AddToFavourite
                    isVisible={showFavourite}
                    setIsVisible={setShowFavourite}
                />
                <LoaderComponent
                    loading={isSearchMode && isExploreDesignLoading}
                >
                    <div
                        className={`design-list-container pb-3 ${
                            viewType === 'NARROW_VIEW' ? 'image-view' : ''
                        }`}
                    >
                        {renderDesigns()}
                    </div>
                    {designs?.length === 0 && (
                        <div className='epmpty-state py-40 text-center m-auto'>
                            <h3 className='text-xl weight-700 gray_400'>
                                No results found
                            </h3>
                            <p className='text-base gray_400'>
                                {isSearchMode
                                    ? 'Please try a different search'
                                    : 'Please try a different filter'}
                            </p>
                        </div>
                    )}
                </LoaderComponent>
            </div>
            {!isSearchMode &&
                !Object.keys(filterStore).length &&
                !filterStore?.isMoreExplore &&
                renderExploreMore()}

            <ScrollTop />
            {showUploadModal && (
                <UploadModal
                    setShowUploadModal={setShowUploadModal}
                    isShowImageSearch={true}
                />
            )}
            {openModal && (
                <BuildRangeRightSidePanel
                    openModal={openModal}
                    onCloseModal={onCloseModal}
                />
            )}
        </LoaderComponent>
    )
}

export default ExploreDesign
